// extracted by mini-css-extract-plugin
module.exports = {"declaration":"A5x39DLmjmtC7o25ZjzJ7A==","footer":"Sshd+l58OIRriMT6MbC8+Q=="};